import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "16",
  viewBox: "0 0 18 16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("ellipse", {
      cx: "9.02211",
      cy: "7.97266",
      rx: "8.06556",
      ry: "7.93925",
      transform: "rotate(0.629221 9.02211 7.97266)",
      fill: "#E80202",
      "fill-opacity": "0.74"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.49629 4.24437C6.17037 3.91845 5.57036 3.91859 5.24444 4.24451C4.91852 4.57044 4.91852 5.17025 5.24444 5.49618L7.81974 8.00022L5.24445 10.5037C4.91853 10.8296 4.91853 11.4296 5.24445 11.7556C5.57037 12.0815 6.17038 12.0815 6.4963 11.7556L9 9.1805L11.5037 11.7556C11.8296 12.0815 12.4296 12.0815 12.7556 11.7556C13.0815 11.4296 13.0815 10.8296 12.7556 10.5037L10.1803 8.00022L12.7556 5.49647C13.0815 5.17055 13.0815 4.57052 12.7556 4.2446C12.4296 3.91867 11.8296 3.91867 11.5037 4.2446L9 6.81994L6.49629 4.24437Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }